import { Grid, Typography, Box, TextField } from "@mui/material"
import { useAppSelector } from "../../../hooks/store-hooks"
import { usePasswordRecoveryService } from "../../../../use-cases/auth/usePasswordRecoveryService"

export const ValidateCodeForm = () => {
  const validateCodeForm = useAppSelector((state) => state.auth.validateCodeForm)
  const email = useAppSelector((state) => state.auth.requestNewPasswordForm.fields.email)
  const {
    setValidateCodeFormCode
  } = usePasswordRecoveryService()
  return <>
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Typography variant="h5" component="h1" align="center" color="primary" fontWeight="bold">
          Recuperar senha
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography variant="body1" component="p" align="center">
          Insira o código de verificação que enviamos para o endereço de e-mail <span style={{
            fontWeight: 'bold'
          }}>{email} </span> no campo de texto abaixo e clique em "Próximo". Em seguida, você será redirecionado para a página de criação de nova senha.
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Box mt={3}>
          <Typography variant="body1" component="p" align="center" fontWeight="bold">
            Lembre-se de seguir todas as instruções fornecidas pelo sistema para garantir a segurança da sua conta. Se você tiver problemas para recuperar sua senha, entre em contato com o suporte ao cliente para obter ajuda adicional.
          </Typography>
        </Box>
      </Grid>
      <Grid item xs={12}>
        <TextField
          label="Código de verificação"
          value={validateCodeForm.fields.code}
          onChange={(e) => {
            setValidateCodeFormCode({
              code: e.target.value
            })
          }}
          error={Boolean(validateCodeForm.touched && validateCodeForm.errors.find(item => item.key === 'code'))}
          helperText={
            validateCodeForm.errors.find(item => item.key === 'code')?.message
          }
          name="name"
          fullWidth
          id="name"
          autoFocus/>
      </Grid>
    </Grid>
  </>
}